import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SEO from '../components/SEO';
import PropertyCard from '../components/PropertyCard';
import { CERTIFICATIONS } from '../utils/constants';
import './OurTeam.css';

const OurTeam = () => {
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [agentProperties, setAgentProperties] = useState([]);
  const [loading, setLoading] = useState(false);

  const agents = [
    {
      name1: 'Noemi Alicea Gonzalez',
      name: 'Noemi Alicea',
      license: 'Lic. C-16344',
      fullName: 'Noemí Alicea González, Lic. C-16344',
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2FPicture3.png?alt=media&token=66d381c9-39fc-49f9-a322-8ac5389eac40',
      bio: `Con experiencia en el sector de Bienes Raíces desde 2009.
        Miembro activa de la National Association of REALTORS® (NAR), Puerto Rico Association of REALTORS® (PRAR) y Mid Island Association of REALTORS® (MIAR) desde 2009 hasta el presente.
        Corredora autorizada de propiedades HUD y de Show Selling Broker.
        Presidenta Electa del Mid Island Association of REALTORS®, Inc. para el año 2025.
        Presidenta del Comité de Educación del Mid Island Association of REALTORS®, Inc. (2025).
        Presidenta del Comité de Nuevos Socios del Mid Island Association of REALTORS®, Inc. (2025).`,
      email: 'alicearealtygroupllc@gmail.com',
      phone: '(787) 342-1648',
      credentials: ['ABR', 'GREEN', 'e-PRO', 'RENE', 'SFR', 'C2EX', 'PSA', 'L.E.A.D.', 'AHWD', 'LTA']
    },
    {
      name1: 'Lina Lucia Díaz Marrero',
      name: 'Lina Lucia',
      license: 'Lic. C-25653',
      fullName: 'Lina Lucia Díaz Marrero, Lic. C-25653',
      image: 'https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2FPicture4.jpg?alt=media&token=cc0ed119-3a27-467d-9265-8ae6c3c40ac0',
      bio: 'Miembra del National Association of Realtors, Puerto Rico Association of Realtors y Mid-Island Association of Realtors.',
      email: 'linadiaz.alicearealtygroupllc@gmail.com',
      phone: '(787) 516-7677',
      credentials: ['GREEN', 'LTA']
    }
  ];

  useEffect(() => {
    if (selectedAgent) {
      fetchAgentProperties(selectedAgent.name);
    }
  }, [selectedAgent]);

  const fetchAgentProperties = async (agentName) => {
    setLoading(true);
    try {
      const response = await axios.get('/api/properties?limit=100');
      const allProperties = response.data.properties || response.data;
      // Filter to show only properties by this agent that are for-sale or for-rent (exclude sold)
      const filtered = allProperties.filter(prop => 
        prop.agent === agentName && 
        (prop.listingType === 'for-sale' || prop.listingType === 'for-rent')
      );
      setAgentProperties(filtered);
    } catch (error) {
      console.error('Error fetching agent properties:', error);
      setAgentProperties([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAgentClick = (agent) => {
    setSelectedAgent(agent);
  };

  const closeOverlay = () => {
    setSelectedAgent(null);
    setAgentProperties([]);
  };

  return (
    <div className="our-team">
      <SEO 
        title="Nuestro Equipo | Alicea Realty Group LLC | Noemi Alicea"
        description="Conoce a nuestro equipo de profesionales en bienes raíces. Noemí Alicea González (Noemi Alicea) y Lina Lucia Díaz Marrero, corredoras autorizadas en Puerto Rico."
        keywords="equipo bienes raíces Puerto Rico, realtors Puerto Rico, Noemí Alicea González, Noemi Alicea, Lina Lucia Díaz Marrero, Alicea Realty Group, Mid Island Association of REALTORS"
        ogTitle="Nuestro Equipo | Alicea Realty Group LLC"
        ogDescription="Conoce a nuestro equipo de profesionales en bienes raíces"
        canonical="https://www.alicearealtypr.com/our-team"
      />
      
      <section className="team-hero">
        <div className="team-hero-content">
          <h1>Nuestro Equipo</h1>
        </div>
      </section>

      <section className="team-content">
        <div className="container">
          <div className="team-realtors">
            <h2>Realtors</h2>
            <div className="realtors-grid">
              {agents.map((agent) => (
                <div 
                  key={agent.name} 
                  className="realtor-card"
                  onClick={() => handleAgentClick(agent)}
                >
                  <div className="realtor-image">
                    <img src={agent.image} alt={agent.fullName} />
                  </div>
                  <div className="realtor-info">
                    <h3>{agent.name}</h3>
                    <h3>{agent.license}</h3>
                    <h3>{agent.phone}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="about-certifications">
            <h2>Certificaciones</h2>
            <div className="certifications-grid">
              {CERTIFICATIONS.map((cert) => (
                <div key={cert.id} className="certification-item">
                  <img src={cert.src} alt={cert.alt} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {selectedAgent && (
        <div className="agent-overlay" onClick={closeOverlay}>
          <div className="agent-overlay-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-overlay" onClick={closeOverlay}>×</button>
            
            <div className="agent-overlay-header">
              <div className="agent-overlay-image">
                <img src={selectedAgent.image} alt={selectedAgent.fullName} />
              </div>
              <div className="agent-overlay-info">
                <h2>{selectedAgent.fullName}</h2>
                <p className="agent-bio">{selectedAgent.bio}</p>
                <p className="agent-contact">
                  <strong>Correo:</strong>{' '}
                  <a href={`mailto:${selectedAgent.email}`}>{selectedAgent.email}</a>
                </p>
                <p className="agent-contact">
                  <strong>Teléfono:</strong>{' '}
                  <a href={`tel:${selectedAgent.phone.replace(/[^0-9]/g, '')}`}>{selectedAgent.phone}</a>
                </p>
                <div className="agent-credentials">
                  <p><strong>Credenciales:</strong></p>
                  <ul>
                    {selectedAgent.credentials.map((cred) => (
                      <li key={cred}>{cred}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="agent-listings">
              <h3>Propiedades de {selectedAgent.name1}</h3>
              {loading ? (
                <p>Cargando propiedades...</p>
              ) : agentProperties.length > 0 ? (
                <div className="agent-properties-grid">
                  {agentProperties.map((property) => (
                    <PropertyCard key={property.id} property={property} />
                  ))}
                </div>
              ) : (
                <p>No hay propiedades asignadas a este agente actualmente.</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OurTeam;
